import { NotificationType } from 'features/notifications/notifications.types';
import { isGeoEventUpgradedFromSilent } from 'features/geoEvents/geoEvent.utils';

export type GeoEventNotificationPreviewStateInput = {
  geoEvent?: { notificationType: NotificationType };
  /** Current value of the form's incident notification type. */
  currentNotificationType: NotificationType;
  regionsAdded: boolean;
  title: string;
  body: string;
  isDirty: boolean;
  sendsNotifications: boolean;
};

type GeoEventNotificationPreviewState = {
  showPreviewSection: boolean;
  showPreview: boolean;
  showNoNotificationNote: boolean;
};

/**
 * Decides whether an incident form shows the push notification preview, and
 * whether it shows the "no push notification will be sent" note instead.
 */
export const getGeoEventNotificationPreviewState = (
  input: GeoEventNotificationPreviewStateInput,
): GeoEventNotificationPreviewState => {
  const {
    geoEvent,
    currentNotificationType,
    regionsAdded,
    title,
    body,
    isDirty,
    sendsNotifications,
  } = input;

  const isUpgradedFromSilent = isGeoEventUpgradedFromSilent({
    previousNotificationType: geoEvent?.notificationType,
    currentNotificationType,
  });

  // Staying silent while regions are added still notifies (to the silent
  // topic on the backend), so the preview should show in that case too.
  const notifiesOnEdit = isUpgradedFromSilent || regionsAdded;

  const showPreviewSection =
    sendsNotifications && (geoEvent ? notifiesOnEdit : true);

  return {
    showPreviewSection,
    // Added regions must show a preview even with no body text.
    showPreview:
      showPreviewSection && Boolean(title) && (regionsAdded || Boolean(body)),
    showNoNotificationNote: geoEvent
      ? isDirty && !showPreviewSection
      : !showPreviewSection,
  };
};
